<!-- Tabs -->

<div class="dashboard-tabs-container">
    <div class="dashboard-tabs">
        <button type="button" class="dashboard-tab" *ngIf="canView.types"
            [class.active]="activeTab === 'types'"
            (click)="onTabChange('types')">
            Tipos de documento
        </button>
        <button type="button" class="dashboard-tab" *ngIf="canView.witnesses"
            [class.active]="activeTab === 'witnesses'"
            (click)="onTabChange('witnesses')">
            Testemunhas
        </button>
        <button type="button" class="dashboard-tab" *ngIf="canView.models"
            [class.active]="activeTab === 'models'"
            (click)="onTabChange('models')">
            Templates de minuta
        </button>
        <button type="button" class="dashboard-tab" *ngIf="canView.bonds"
            [class.active]="activeTab === 'bonds'"
            (click)="onTabChange('bonds')">
            Vincular minutas
        </button>
        <button type="button" class="dashboard-tab" *ngIf="canView.variables"
            [class.active]="activeTab === 'variables'"
            (click)="onTabChange('variables')">
            Dicionário de variáveis
        </button>
    </div>
</div>


<div class="row align-items-start">
    <div class="col-12">
        <!-- Tipos de documento -->
        <ng-container *ngIf="shouldShowCard('types')">
            <app-dashboard-drafts-versions></app-dashboard-drafts-versions>
        </ng-container>

        <!-- Variáveis -->
        <ng-container *ngIf="shouldShowCard('variables')">
            <app-dashboard-drafts-variables-list></app-dashboard-drafts-variables-list>
        </ng-container>

        <!-- Templates de minutas -->
        <ng-container *ngIf="shouldShowCard('models')">
            <app-dashboard-drafts-models-list></app-dashboard-drafts-models-list>
        </ng-container>

        <!-- Vínculo de minutas -->
        <ng-container *ngIf="shouldShowCard('bonds')">
            <app-dashboard-drafts-bonds></app-dashboard-drafts-bonds>
        </ng-container>

        <!-- Testemunhas -->
        <ng-container *ngIf="shouldShowCard('witnesses')">
            <app-dashboard-witnesses></app-dashboard-witnesses>
        </ng-container>
    </div>
</div>